import _ from "lodash";
import { flow, types } from "mobx-state-tree";
import { getEnv } from "../../utils/getEnv";
import { Terms } from "./Terms";
import type { TermsInstance } from "./Terms";
import type { AxiosResponse } from "axios";

export const TermsStore = types
  .model("TermsStore", {
    map: types.map(Terms),
  })
  .actions((self) => ({
    process(data: any, token: string): any {
      data.token = token;
      const dataList = _.castArray(data);
      const mapped = dataList.map((terms) => {
        const existingTerms = self.map.get(terms.token);
        return existingTerms
          ? _.mergeWith(existingTerms, terms, (_, next) => {
              if (Array.isArray(next)) return next; // Treat arrays like atoms
            })
          : self.map.put(terms);
      });
      return Array.isArray(data) ? mapped : mapped[0];
    },
  }))
  .actions((self) => {
    return {
      // will return BadRequest with the code "4003400" and message "Missing token" if the token is missing
      // will return BadRequest with the code "4003400" and message  "Missing or Invalid number of data values" if the token is invalid,
      // will return BadRequest with the code "4003400" and message  "Data is missing or incorrect" if client, clinic or appointment cant be found.
      // will return BadRequest with the code "4095700" and message  "Appointment has already ended." if the endDate of appointment has passed
      readDataForTermsAndConditionsConsent: flow<TermsInstance, [string]>(
        function* readDataForTermsAndConditionsConsent(token): any {
          const env = getEnv(self);

          const response: AxiosResponse = yield env.tosHttp.get(
            `/v2/termsandconditions/${token}`,
          );
          response.data = self.process(response.data, token);

          return response.data;
        },
      ),
    };
  });
